<vectronic-card [title]="data.title" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body>
    <div class="input-dialog-content">
      <p>
        {{ data.text }}
      </p>
      @if (data.lines === 1) {
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [(ngModel)]="result" #inputField [placeholder]="data.placeholder ?? ''" />
        </mat-form-field>
      } @else {
        <mat-form-field appearance="outline" class="full-width">
          <textarea
            [rows]="data.lines"
            matInput
            [(ngModel)]="result"
            #inputField
            [placeholder]="data.placeholder ?? ''"
          ></textarea>
        </mat-form-field>
      }
      <div class="actions">
        <button mat-button (click)="submit()">
          <mat-icon color="accent">check</mat-icon>
          OK
        </button>
        <button mat-button [mat-dialog-close]="false">
          <mat-icon color="warn">cancel</mat-icon>
          Cancel
        </button>
      </div>
    </div>
  </ng-container>
</vectronic-card>
